import { useNavigate } from "react-router-dom";
import { useGame } from "../contexts/GameContext";

export const Intro = () => {
    const { reset } = useGame();
    const navigate = useNavigate();

    function handleStart() {
        reset();
        navigate(`quizz`);
    }

    return (
        <div className="intro">
            <header>
                <h1>Corpo e defesas em ação</h1>
            </header>

            <button className="btn" onClick={handleStart}>Iniciar</button>
        </div>
    );
}